<template>
<AuthenticatedLayout>
  <div class="task-details-container">
    <header class="task-header">
      <h1 class="task-title">#{{ task.id }} | {{ task.title }}</h1>      

      <el-alert v-if="task.stage !== 4 && task.deadline.days_left > 1  && !task.deadline.overdue" :title="`Você tem até ${task.deadline.days_left} dias para concluir esta tarefa`" type="success" effect="dark" />
      <el-alert v-if="task.stage !== 4 && task.deadline.days_left == 1 && !task.deadline.overdue" :title="`Você tem até amanhã para concluir esta tarefa`" type="info" effect="dark" />
      <el-alert v-if="task.stage !== 4 && task.deadline.days_left == 0 && task.deadline.overdue" :title="`ATENÇÃO! Você tem até hoje para concluir esta tarefa`" type="warning" effect="dark" />
      <el-alert v-if="task.stage !== 4 && task.deadline.days_left > 0 && task.deadline.overdue" :title="`ATENÇÃO! Esta tarefa esta atrasada! Em ${task.deadline.days_left} dia(s).`" type="error" effect="dark" /> 
      
        <el-alert 
          v-if="task.stage == 4" :title="`Tarefa concluída em ${task.completion_date}, você trabalhou nesta tarefa por ${task.workHours}`" 
          type="success" 
          effect="dark" 
          />

    </header>

    <section>
      <el-row :gutter="20">
        <el-col :span="24">

          <el-card>
            <template #header>
              <div class="card-header">
                <span>Informações da Tarefa</span>

                <div>
                  <span v-if="task.stage < 4">
                    <el-button v-if="!isWork" type="success" @click="startTask()">
                      <el-icon><VideoPlay /></el-icon>
                      Iniciar Trabalho
                    </el-button>
                    <el-button v-else type="warning" @click="pauseTask()">
                      <el-icon><VideoPause /></el-icon>
                      {{ timer }}                    
                    </el-button>                    
                    <el-button type="primary" @click="handleOpenDrawer()">
                      <el-icon><Edit /></el-icon>
                      Atualizar Tarefa
                    </el-button>
                  </span>
                  <el-button class="btn-back" type="info" @click="goToBack()">
                    <el-icon><Back /></el-icon>
                    Voltar
                  </el-button>
                </div>
              </div>
            </template>
            
            <el-row :gutter="10">
              <el-col :span="18">
                <div class="task-info">
                  <div v-if="task.client_name" class="task-description" style="margin-bottom: 10px;">
                    <h3>Cliente:</h3>
                    <p v-html="task.client_name"></p>
                  </div>
                  
                  <div class="task-description">
                    <h3>Descrição:</h3>
                    <div class="content" v-html="task.description"></div>
                  </div>
                  
                  
                  <div class="task-categories">
                    <h3>Categorias</h3>
                    <el-tag
                      v-for="(category, index) in task.categories"
                      :key="index"
                      type="warning"
                      class="category-tag"
                      >
                      {{ category.name }}
                    </el-tag>
                  </div>
                </div>
              </el-col>

              <el-col :span="6">
                <div class="task-details">
                  <b>Prioridade:</b>
                  <task-priority :type="task.priority" />
                </div>

                <div class="task-details">
                  <b>Data de Início:</b>
                  {{ task.start_date }}
                </div>

                <div class="task-details">
                  <b>Prazo de Entrega:</b>
                  <span class="deadline">{{ task.expected_date }}</span>
                </div>

                <div class="task-details">
                  <b>Autor:</b> {{ task.author_name }}
                </div>

                <div class="task-details">
                  <b>Responsável:</b> {{ task.responsible_name }}
                </div>

              </el-col>
            </el-row>

            <template #footer>
              <el-row :gutter="10">
                <el-col :span="10"> 
                  Você pode atualizar ao lado o status desta tarefa                
                </el-col>
                <el-col :span="14" style="text-align: right">
                  <el-button-group>
                    <el-button
                      v-for="(stage, index) in stages"
                      :key="index"
                      :type="stage.id === task.stage ? 'primary' : 'default'"
                      @click="changeStage(stage.id)"
                    >
                      {{ stage.name }}
                    </el-button>
                  </el-button-group>
                </el-col>
              </el-row>
            </template>
          </el-card>

        </el-col>

      </el-row>
    </section>

    <section class="task-actions">
      <el-tabs type="border-card" class="demo-tabs">        
        <el-tab-pane label="Comentário">
          <TaskComments :taskId="Number(taskId)" />
        </el-tab-pane>
        <el-tab-pane label="Tempo de Trabalho">
          <el-timeline style="width: 100%">
            <el-timeline-item
              v-for="(activity, index) in activities"
              :key="index"
              icon="Clock"
              type="success"              
              size="large"
              :hollow="activity.hollow"
              :timestamp="activity.updated_at"
            >
              {{ activity.message }}
            </el-timeline-item>
          </el-timeline>
        </el-tab-pane><!-- tempo de trabalho-->
        
        <el-tab-pane label="Anexos">Anexos da Tarefa</el-tab-pane>
        <el-tab-pane label="Logs">Logs da tarefa</el-tab-pane>
      </el-tabs>
    </section>

  </div>

  
  <el-drawer v-model="drawer">
    <template #header>
      <h4>Atualize abaixos os dados desta tarefa</h4>
    </template>
    <template #default>
        <el-form label-position="top" :model="taskForm">

          <el-form-item label="Título">
              <el-input v-model="taskForm.title" />
          </el-form-item>
              
          <el-form-item label="Descrição">
              <QuillEditor v-model="taskForm.description" placeholder="Digite aqui os detalhes da tarefa..." />
          </el-form-item>

          <el-form-item label="Cliente">
            <el-select filterable v-model="taskForm.client" placeholder="Selecione o Cliente">
            <el-option
                v-for="user in activeClients"
                :key="user.id"
                :label="user.name"
                :value="user.id"
            />
            </el-select>
        </el-form-item>
          
          <el-form-item label="Categorias">
              <el-select
                  v-model="taskForm.categories"
                  multiple
                  placeholder="Selecione as categorias"
              >
                  <el-option 
                      v-for="category in categories" 
                      :key="category.id" 
                      :label="category.name" 
                      :value="category.id" 
                  />
              </el-select>
          </el-form-item>
        
          <el-form-item label="Data de Início">
              <el-date-picker v-model="taskForm.startDate" type="date" placeholder="Selecione a data de início" />
          </el-form-item>
          
          <el-form-item label="Prazo de Conclusão">
              <el-date-picker v-model="taskForm.deadline" type="date" placeholder="Selecione o prazo de conclusão" />
          </el-form-item>
          
          <el-form-item label="Urgência">
              <el-select v-model="taskForm.urgency" placeholder="Selecione a urgência">
                  <el-option label="Baixa" value="0" />
                  <el-option label="Média" value="1" />
                  <el-option label="Alta" value="2" />
              </el-select>
          </el-form-item>

          <el-form-item label="Autor da Tarefa">
              <el-input v-model="taskForm.author" :disabled="true" />
          </el-form-item>

          <el-form-item label="Pessoa Responsável">
              <el-select v-model="taskForm.responsible" placeholder="Selecione a pessoa responsável">
              <el-option
                  v-for="user in activeUsers"
                  :key="user.id"
                  :label="user.name"
                  :value="user.id"
              />
              </el-select>
          </el-form-item>

          <el-form-item label="Estágio">
              <el-select v-model="taskForm.stage" placeholder="Selecione o Estágio">
                  <el-option label="A Fazer" value="0" />
                  <el-option label="Fazendo" value="1" />
                  <el-option label="Pendente" value="2" />
                  <el-option label="Validando" value="3" />
                  <el-option label="Concluída" value="4" />
                  <el-option label="Arquivada" value="5" />
              </el-select>
          </el-form-item>         

        </el-form>
    </template>
    <template #footer>
      <div style="flex: auto">
        <el-button @click="closeDrawer()">Fechar</el-button>
        <el-button type="primary" @click="handleSubmit()">Salvar</el-button>
      </div>
    </template>
  </el-drawer>
</AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from "@/layouts/AuthenticatedLayout";
import TaskComments from "@/components/TaskComments.vue";
import { getById, updateTasks, workLog, workTime } from "@/services/taskService";
import TaskPriority from "@/components/TaskPriority";
import QuillEditor from '@/components/QuillEditor.vue';
import { mapGetters } from "vuex";
import { ElNotification } from "element-plus";

export default {
  components: {
    AuthenticatedLayout,
    TaskPriority,
    QuillEditor,
    TaskComments
  },  
  data() {
    return {
      taskId: null,
      task: {
        title: "",
        description: "",
        start_date: "",
        deadline: "",
        priority: "",
        author_name: "",
        responsible_name: "",
        stage: "",
        client: "",
        categories: [],
      },
      stages: [
        { id: 0, name: "A Fazer" },
        { id: 1, name: "Fazendo" },
        { id: 2, name: "Pendente" },
        { id: 3, name: "Validando" },
        { id: 4, name: "Concluído" },
        { id: 5, name: "Arquivar" },
      ],
      fileList: [],
      taskForm: [],
      drawer: false,
      newComment: "",
      comments: [],
      loading: false,
      activities: [],
      isWork: false,
      timer: "00:00:00",
      intervalId: null
    };
  },
  created() {
    this.taskId = this.$route.params.id;
    this.getData();
    this.getWorkLog(); 
  },
  watch: {
    '$route'(to, from) {
      console.log('chamou heim')
      if (to.params.id !== from.params.id) {

        this.taskId = to.params.id;
        this.getData();

        console.log('vai carregar a nova? ', to.params.id, ' > ', from.params.id)
        
      }
    }
  },
  computed: {        
      ...mapGetters('taskData', [
          'taskCategories',
          'activeUsers',
          'activeClients'        
      ]),

      categories() {            
          console.log(this.taskCategories)
          return this.taskCategories;
      }
  },
  methods: {
    async getData() {
      this.loading = true;
      try {
        
        const response = await getById(this.taskId);
        this.task = response.data;
        this.isWork = this.task.isWork;
        if (this.isWork) {
          this.task.timer = new Date(this.task.workTime.start_date);
          this.startTime(true);
        }
      } catch (error) {
        this.$message.error("Erro ao carregar dados da tarefa");
      } finally {
        this.loading = true;
      }
    },
    handleOpenDrawer() {     
      this.taskForm = {
          id: this.task.id,           
          title: this.task.title,
          description: this.task.description,          
          startDate: this.task.start_date_full,
          deadline: this.task.expected_date_full,                
          urgency: String(this.task.priority),
          author: this.task.author_name,
          author_id: this.task.author_id,
          responsible: this.task.responsible_id,
          stage: String(this.task.stage),
          client: this.task.client_id
      }
      this.getCategoriesId();
      this.drawer = true;
    },
    closeDrawer() {
      this.drawer = false;            
    },
    async handleSubmit() {
      this.loading = true;
      this.errors = {};
      try {          
          await updateTasks(this.taskForm);
          ElNotification({
              title: 'Atenção!',
              message: 'Registro salvo com sucesso.',
              type: 'success'
          });          

          this.drawer = false;          
          this.getData();
      } catch (error) {
        if (error.errors) {
          const errors = error.errors;
          const errorMessages = Object.values(errors)
                                  .flat()
                                  .join('\n');

          ElNotification({
              title: 'Erro de Validação',
              message: errorMessages,
              dangerouslyUseHTMLString: true,
              type: 'error',
          });          
        } else {
          ElNotification({
              title: 'Erro!',
              message: 'Ocorreu um erro inesperado ao processar a solicitação!',
              type: 'error',
          });
        }
        console.error('error >> ', error)
        this.drawer = true;
      } finally {
        this.drawer = false;           
        this.loading = false;
      }
    },
    goToBack() {
      this.$router.push('/tasks');
    },
    getCategoriesId() {
      const categories = this.task.categories;
      
      const ids = categories.map(task => task.id);
      this.taskForm.categories = ids;
      console.log('CATEGORIES ::: ', categories, ':::::: IDS: ', ids, '::::::: FORM >>> ', this.taskForm)
    },
    async startTask() {
      this.isWork = true;

      const response = await workTime(this.taskId, 'start-time');
      console.log('response de start-time >>> ', response)      
      this.startTime(false);
      this.getData();
      
    },
    async pauseTask() {
      this.isWork = false;

      await workTime(this.taskId, 'pause-time');

      clearInterval(this.intervalId);      
      this.getWorkLog();
    },
    startTime(resume = false) {

      let currentTime = new Date();
      if (resume) {
        currentTime = new Date(this.task.workTime.start_time);
      }      

      this.intervalId = setInterval(() => {
        const now = new Date();
        const diff = Math.floor((now - currentTime) / 1000);

        const hours = String(Math.floor(diff / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
        const seconds = String(diff % 60).padStart(2, "0");

        this.timer = `${hours}:${minutes}:${seconds}`;
      }, 1000);     

    },
    async getWorkLog() {
      const response = await workLog(this.taskId);

      this.activities = response.data;
      
      console.log('logs >>>> ', this.activities)
    },

    handlePreview(file) {
      console.log("Preview file:", file);
    },
    handleRemove(file) {
      console.log("Remove file:", file);
    },
    addComment() {
      if (this.newComment.trim()) {
        this.comments.push(this.newComment);
        this.newComment = "";
      }
    },
    changeStage(newStage) {
      
      this.taskForm = {
          id: this.task.id,           
          stage: String(newStage)
      }

      this.handleSubmit();
      console.log(`Tarefa movida para: ${newStage}`);
      
    },
  },
};
</script>

<style type="scss">
.task-details-container {
  font-size: 14px;
}
.task-header {
  margin-bottom: 10px;

  h1 {
    font-size: 22px;
    color: #333;
    margin-bottom: 10px;
  }
}

.card-header {
  font-weight: bold;  
  display: flex;
  align-items: center;
  justify-content: space-between;

  i {
    margin-right: 5px;
  }
}

.task-info {  
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 14px;
  border-right: 1px dotted #ccc;

  h3 {
    margin-bottom: 5px;
    color: #333;
  }

  .category-tag {
    margin: 0 1px;
  }
}

.task-details {  
  margin: 0 0 10px 0;

  b {
    margin-right: 2px;
  }

  .deadline {
    color: #f00;
  }
}

.task-actions {
  margin-top: 10px;
}
.btn-back {
  margin-left: 10px;
}

.task-description {

  .content {    
    padding: 10px 5px 10px 0;
    font-size: 14px;
    line-height: 1.3rem;    
    
    ul, ol {      
      margin: 5px 15px;

      li {
        margin: 5px 0;
      }
    }
  }
}

</style>
